import { Stack, Text, textVariants } from '@etg/wings';
import { ScreenReaderPrice } from '@eti/components';

interface PriceSectionProps {
  priceDisplayText: string;
  pricePerPerson: string;
}

const PriceSection = ({ priceDisplayText, pricePerPerson }: PriceSectionProps) => {
  return (
    <Stack align="end" spacing={4}>
      <Text aria-hidden data-testid="standard-price" variant={textVariants._24_EMPHASIZED}>
        {pricePerPerson}
      </Text>
      <ScreenReaderPrice price={pricePerPerson} />
      <Text>{priceDisplayText}</Text>
    </Stack>
  );
};

export default PriceSection;
